import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import Navhead from './components/Navhead';
import Navbar from './components/Navbar';
import Carasoul from './components/Carasoul';
import Calculator from './components/Calculator';
import Services from './components/Services ';
import WhoWeAre from './components/Whoweare';
import Footer from './components/Footer';
import Loans from './components/Loans'; // 👈 import your Loans component
import Investments from './components/Investments';
import Personal from './components/Personal';
import ApplyLoan from './components/ApplyLoan';
import AdminLogin from './admin/AdminLogin'

import Authenticate from './admin/Authenticate';
import Insurance from './components/Insurance';
import Contact from './components/Contact';
import About from './components/About';
import Refund from './components/Refund';
import Strip from './components/Strip'

function App() {
  return (
    <Router>
      {/* <Navhead /> */}
      <Navbar />
      <ApplyLoan/>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Carasoul />
              <Strip/>
              <WhoWeAre />
              <Calculator />
              <Services />
              
            </>
          }
        />
        <Route path="/loans" element={<Loans />} /> {/* 👈 Loans route */}
        <Route path="/invest" element={<Investments />} /> {/* 👈 Loans route */}
        <Route path="/insu" element={<Insurance />} /> {/* 👈 Loans route */}
        <Route path="/cont" element={<Contact />} /> {/* 👈 Loans route */}
        <Route path="/about" element={<About />} /> {/* 👈 Loans route */}
        <Route path="/refund" element={<Refund />} /> {/* 👈 Loans route */}
        <Route path="/personal" element={<Personal/>} /> {/* 👈 Loans route */}
        <Route path="/apply-loan" element={<ApplyLoan/>} /> {/* 👈 Loans route */}
      
        <Route path="/admin" element={<AdminLogin/>} /> {/* 👈 Loans route */}
        <Route path="/dashboard" element={<Authenticate />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
